import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SearchBarButtonProps } from '@uncinc/react-searchkit/dist/components/SearchBar/Base';

import Button from '../index';

const SearchBarButton = (buttonProps: SearchBarButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      {...buttonProps}
      type="primary"
      variant="icon-only"
      icon="search"
      aria-label={t('components.search_general.buttons.search')}
    />
  );
};

export default SearchBarButton;
